__turbopack_context__.v({
  "root": "ItemGrid-module__jmNR9G__root",
});
